// extracted by mini-css-extract-plugin
module.exports = {"textSkeleton":"text-skeleton_textSkeleton__4DoZV","shimmer":"text-skeleton_shimmer__sZS7G","video-spin":"text-skeleton_video-spin__HP3Ds","fadeIn":"text-skeleton_fadeIn__YNUIA"};